// FICHIER : frontend/src/components/RequireAuth.jsx
import { Navigate } from 'react-router-dom';

export default function RequireAuth({ children }) {
  const companyId = localStorage.getItem('company_id');
  if (!companyId) return <Navigate to="/entreprise" replace />;
  return children;
}
